import React, { useEffect, useState } from 'react';
import { useStripe, useElements, AddressElement } from '@stripe/react-stripe-js';
import { PaymentElement } from '@stripe/react-stripe-js';
import { Button } from './Button';
import { validateTransaction } from '../services/requests';
import { postParentAnalyticsEvent } from '../analytics/widgetTracking';

interface BillingProps {
	setStep: any;
	amount: number;
	currency: string;
	brandColor?: string;
}
export const BillingForm = ({ brandColor, setStep, amount, currency }: BillingProps) => {
	const stripe = useStripe();
	const elements = useElements();

	const paymentElementOptions = {
		layout: 'tabs' as any,
		mode: 'shipping',
	};

	const [loader, setLoader] = useState(false);

	const buttonConfig = brandColor ? `bg-[${brandColor}] text-white` : `bg-indigo-600 text-white hover:bg-indigo-700`;

	const [message, showMessage] = useState('');

	const handlePrimaryBuyerPayment = async (e: any) => {
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		setLoader(true);

		const response = await stripe.confirmPayment({
			elements,
			confirmParams: {},
			redirect: 'if_required',
		});

		if (response.paymentIntent) {
			const [data, error] = await validateTransaction(response.paymentIntent.id);

			if (data) {
				postParentAnalyticsEvent('cobuyr_payment_succeeded', {
					amount: Number(amount.toFixed(2)),
					currency,
				});
				setStep(4);
			}
		}
		if (response.error) {
			postParentAnalyticsEvent('cobuyr_payment_failed', {
				amount: Number(amount.toFixed(2)),
				currency,
				error_type: response.error.code || response.error.type || 'unknown',
			});
			showMessage(response.error.message || '');
		} else {
			showMessage(`Payment Succeeded: ${response.paymentIntent.id}`);
		}

		setLoader(false);
	};

	return (
		<div className="mb-10">
			<div className="h-full flex flex-col justify-between">
				<div className="mb-4">
					<PaymentElement options={{ ...paymentElementOptions }} />
					<h2 className="text-lg font-semibold my-2">Billing Address</h2>

					<AddressElement options={{ mode: 'billing' }} />
				</div>

				<Button
					title={`Pay ${currency + amount}`}
					className={buttonConfig}
					disabled={false}
					isLoading={loader}
					onClick={(event) => {
						handlePrimaryBuyerPayment(event);
					}}
				/>
			</div>
		</div>
	);
};
